module.exports = __webpack_public_path__ + "img/martjin.44be0f9e.jpeg";